import { RenderElementProps } from 'slate-react';

export const EXERCISE_QUIZ = 'exercise-quiz'; // a wrapper
export const EXERCISE_QUIZ_QUESTIONS = 'exercise-quiz-questions'; // to navigate, create quiz

//
/**
 * to input a quiz - complex fields
 * - field title/children[0]: to input question title
 * - field quizType: text/image/audio
 *
 * ///
 * - field textOptions: ({ id: string, text: string })[]
 * - field imageOptions: ({ id: string, image: FileUploadObject; text: string })[]
 * - field audioOptions: ({ id: string, text: string, audioType: "GOOGLE" | "UPLOAD", audio: FileUploadObject })[]
 * => merge to 1 field options: ({
 *      id: string,
 *      text: string,
 *      imageFile: FileUploadObject,
 *      imageText: string,
 *      audioFile: FileUploadObject
 *      audioType: 'GOOGLE' | 'UPLOAD'
 *      audioText: string
 *  })[]
 * ///
 *
 * - field correctAnswers: id of option - will be reset to null if quizType change
 */
export const EXERCISE_QUIZ_QUESTION = 'exercise-quiz-question';

export const ExerciseQuizSupportTypeEnum = {
  TEXT: 'text',
  IMAGE: 'image',
  AUDIO: 'audio',
} as const;

export type ExerciseQuizSupportTypeEnum =
  (typeof ExerciseQuizSupportTypeEnum)[keyof typeof ExerciseQuizSupportTypeEnum];

export type ExerciseQuizPluginOptions = {
  isReadOnly?: boolean;
  onBackWhenInComplete?: () => void;
};

export type DoTestExerciseQuizProps = ExerciseQuizPluginOptions & RenderElementProps;

export interface QuizOption {
  id: string;
  text?: string;
  imageFile?: any;
  imageText?: string;
  audioFile?: any;
  audioType?: 'GOOGLE' | 'UPLOAD';
  audioText?: string;
}

export interface QuizOptionProps {
  option: QuizOption;
  onOptionChange?: ({ option }: any) => void;
}

export const DoTestQuizAnswerModeEnum = {
  DO_TEST: 'do-test',
  RESULT_WRONG: 'result-wrong',
  RESULT_CORRECT: 'result-correct',
  RESULT_DEFAULT: 'result-default',
} as const;
export type DoTestQuizAnswerModeEnum =
  (typeof DoTestQuizAnswerModeEnum)[keyof typeof DoTestQuizAnswerModeEnum];
